export default "__VITE_ASSET__B24Xvm8K__"